<template>
  <router-view></router-view>
</template>

<script>
    import {mapMutations} from 'vuex'

    export default {
        name: 'App',
        data() {
            return {
                //
            }
        },
        methods: {
            ...mapMutations('notification', ['showSnackbar'])
        },
        created() {
            let that = this
            this.$http.interceptors.response.use(
                function (response) {
                    if (response.data.Error === -5010 || response.data.Error === -6) {
                        that.$store.dispatch('auth/signout', false)
                        that.showSnackbar({text: 'Token expired. Please log in again.', type: 'error'})
                        that.$router.push({path: '/', query: that.$route.query})
                    }
                    return Promise.resolve(response)
                },
                function (error) {
                    that.showSnackbar({text: 'Network Error', type: 'error'})
                    return Promise.reject(error)
                });
        }
    }
</script>

